import { render } from "./capital-explorer-for-visitors.view.vue?vue&type=template&id=2372379f&scoped=true&ts=true"
import script from "./capital-explorer-for-visitors.view.vue?vue&type=script&lang=ts"
export * from "./capital-explorer-for-visitors.view.vue?vue&type=script&lang=ts"

import "./capital-explorer-for-visitors.view.vue?vue&type=style&index=0&id=2372379f&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2372379f"]])

export default __exports__